<!-- Page header -->
<div class="pageheader">
  <div class="page-title">
    <h1>Monitor item</h1>
    <div class="btn-group">
      <button class="btn btn-link" [disabled]="vm.editing || (vm.monitorItem.id < 1)" (click)="refresh()">
        <span>Refresh</span>
        <ep-svg-icon icon="repeat"></ep-svg-icon>
      </button>
      <button class="btn btn-link" *bizPermissionRequired="'Monitor_Action_Item_Create'" [disabled]="vm.editing"
        (click)="addNewItem()">
        <span>Create new</span>
        <ep-svg-icon icon="plus"></ep-svg-icon>
      </button>
      <app-change-log-link [hidden]="!vm.monitorItem.id" *bizPermissionRequired="'Monitor_Action_ShowLog'"
        [title]="'Monitor item log'">
        <app-change-log-link-entity type="MonitorItem" [id]="vm.monitorItem.id"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>

<!-- Container -->
<div class="container container-fixed">

  <!-- Button bar -->
  <div class="row">
    <div class="col-sm-12">

      <div class="form-group btn-toolbar">
        @if (!vm.editing) {
          <div class="btn-group">
            <button type="button" class="btn btn-primary btn-sm" (click)="edit()"
              *bizPermissionRequired="['Monitor_Action_Item_Create', 'Monitor_Action_Item_Edit']">
              Edit
            </button>
          </div>
        }
        @if (vm.editing) {
          <div class="btn-group">
            <button type="button" class="btn btn-primary btn-sm" [disabled]="!canSave" (click)="save()">Save</button>
          </div>
        }
        @if (vm.editing) {
          <div class="btn-group">
            <button type="button" class="btn btn-link btn-sm" (click)="cancel()">Cancel</button>
          </div>
        }
        <div class="btn-group">
          <button type="button" class="btn btn-primary btn-sm" (click)="deleteItem(vm.monitorItem.id)"
            [disabled]="vm.editing" *bizPermissionRequired="'Monitor_Action_Item_Delete'">
            Delete
          </button>
        </div>
        @if (vm.monitorItem.absenceItemTemplate === null) {
          <div class="btn-group">
            <button *bizPermissionRequired="'Monitor_Action_Item_Edit'" class="btn btn-primary btn-sm" [disabled]="vm.editing || vm.monitorItem.enabled === false" (click)="pauseMonitor()">Pause Monitor</button>
          </div>
        }
        @if (vm.monitorItem.absenceItemTemplate !== null) {
          <div class="btn-group">
            <button *bizPermissionRequired="'Monitor_Action_Item_Edit'" class="btn btn-primary btn-sm" [disabled]="vm.editing" (click)="resumeMonitor()">Resume Monitor</button>
          </div>
        }
        @if (canGotoEmbeddedItem(vm.monitorItem)) {
          <div class="btn-group">
            <button type="button" class="btn btn-primary btn-sm" (click)="gotoEmbeddedItem(vm.monitorItem)"
              [disabled]="vm.editing">
              {{getButtonLabel(vm.monitorItem)}}
            </button>
          </div>
        }
      </div>

    </div>
  </div>

  @if (vm.monitorItem.absenceItemTemplate) {
    <div class="panel panel-default panel-body">
      <h1>Monitor paused</h1>
      <h3>Reason: {{vm.monitorItem.absenceItemTemplate?.Note}}</h3>
      <h3>Resumes at: {{getAbsenceExpireDate()}}</h3>
    </div>
  }

  <h1>Item configuration</h1>

  <!-- The Form -->
  <form #theForm="ngForm" [formGroup]="formData" novalidate>
    <app-monitor-item-edit formControlName="monitorItem" [stakeholders]="vm.stakeholders"
      [monitorSchedules]="vm.monitorSchedules" [monitorGroups]="vm.monitorGroups">
    </app-monitor-item-edit>
  </form>

</div> <!-- End container -->
